import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {NgForm} from "@angular/forms";
import {ThreeWordsService} from "../../services/3Words/three-words.service";
import {GeoLibService} from "../../services/geoLib/geo-lib.service";
import {CesiumAdapterService} from "../../services/cesiumAdapter21/cesium-adapter.service";
import {MapPosition} from "../../models/MapPosition";
import {Observable, Observer, of} from "rxjs";
import {map, switchMap} from "rxjs/operators";
import {HttpServiceService} from "../../services/httpService/http-service.service";
import {SearchLocationComponent} from "../../components/search-location/search-location.component";
// var focusLatLng = drawingManager.getMap().getCenter();
const typeHeadUrl = 'https://api.what3words.com/v3/autosuggest?key=MXCP10V7&language=en&format=json';

@Component({
  selector: 'app-search-location',
  templateUrl: './search-location.component.html',
  styleUrls: ['./search-location.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})


export class SearchLocationComponent21 extends SearchLocationComponent{}
